import createCache from '@emotion/cache';

/**
 * Creates an Emotion cache for SSR support with MUI and tss-react.
 *
 * This is required for proper server-side rendering with Turbopack.
 * The cache ensures styles are extracted during SSR and hydrated correctly on the client.
 *
 * @see https://docs.tss-react.dev/ssr
 * @see https://mui.com/material-ui/guides/server-rendering/
 */
export function createEmotionCache() {
  return createCache({ key: 'css', prepend: true });
}
